import { createIcon } from '../createIcon';
import { ReactComponent as IconChartLine } from '../svg/chart-line.svg';

export default createIcon(IconChartLine);
